/** `notes_list` — structured notes on the gig (incl. chat-added notes, which were invisible in v1). */
import { z } from "zod";
import { defineCollection, field } from "../define.ts";

export const notes_list = defineCollection({
  key: "notes_list",
  labelKey: "collections.notes_list",
  icon: "sticky-note",
  sheetTab: "Notes",
  dedupFields: ["title"],
  sort: [{ field: "title" }],
  split: "gig",
  chatHint: "Titled notes on the gig. 'Note that X' creates a row here — always visible in Files & Notes.",
  fields: {
    title: field({
      type: z.string().min(1),
      tier: "hot",
      pii: "crew",
      labelKey: "notes_list.title",
      sheet: { column: "Title" },
      description: "Note title.",
    }),
    body: field({
      type: z.string().optional(),
      tier: "hot",
      pii: "crew",
      labelKey: "notes_list.body",
      sheet: { column: "Body" },
      description: "Note content.",
    }),
  },
});
